export const homeImages = [
  {
    imgNum: 1,
    imgSrc: "Header Carousel/header_1.jpg",
    title: "GROUPS",
    subTitle: "",
    desc: "Gather your group for an unforgettable time together at the ballpark! Explore the options for your crew of 15+ guests at the beautiful, climate-controlled Globe Life Field.",
    caption: "",
    links: [
      {
        linkNum: 1,
        linkTitle: "",
        linkDesc: "Want to rent a suite for a game?",
        linkURL: "/suite-rentals",
      },
      {
        linkNum: 2,
        linkTitle: "GET TICKETS FROM JUST $9!",
        linkDesc:
          "<p>Book your group or place your deposit before <u><strong>January 1</strong></u> and you'll save 25% with Early Bird Pricing.</p>",
        linkURL: "/season-suites",
      },
    ],
  },
  {
    imgNum: 3,
    imgSrc: "Header Carousel/header_3.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "",
    links: [],
  },
  {
    imgNum: 4,
    imgSrc: "Header Carousel/header_4.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "",
    links: [],
  },
  {
    imgNum: 5,
    imgSrc: "Header Carousel/header_5.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "",
    links: [],
  },
  {
    imgNum: 6,
    imgSrc: "Header Carousel/header_6.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "",
    links: [],
  },
  // {
  //   imgNum: 7,
  //   imgSrc: "Header Carousel/header_8.jpg",
  //   title: "",
  //   subTitle: "",
  //   desc: "",
  //   caption: "",
  //   links: [],
  // },
];
